import { atom } from "nanostores"

export const $downloadEvent = atom<any | null>(null)

